import { ContaItemBase } from "core/features/conta/typings";
import http from "infra/http";
import { useQuery } from "react-query";

interface UseGetContasRateioProps {
  id?: string;
  year: string;
  month: string;
}

function useGetContasRateio({id, year, month}: UseGetContasRateioProps) {
  return useQuery(`/v1/rateio/${id}/${year}/${month}/contas`, async () => {
    const { data } = await http.get(`/v1/rateio/${id}/${year}/${month}/contas`);
    return data as ContaItemBase[];
  }, {
    enabled: !!id,
  });
}

export default useGetContasRateio;
